var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h4',{staticStyle:{"color":"#000"}},[_vm._v("Welcome ,欢迎使用动优康复后台管理系统")])])])
}]

export { render, staticRenderFns }